// extracted by mini-css-extract-plugin
module.exports = {"buttonNoBorder":"customButton_buttonNoBorder__c2rla","buttonGradient":"customButton_buttonGradient__kmO_W","buttonOnlyBorder":"customButton_buttonOnlyBorder__7oVrY"};